export const GET_HISTORIES = "GET_HISTORIES";
export const DELETE_HISTORY = "DELETE_HISTORY";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_HISTORY = "CLEAR_HISTORY";
